// extracted by mini-css-extract-plugin
module.exports = {"app-bar":"_2E8hH2r5 flex fixed bottom-0","appBar":"_2E8hH2r5 flex fixed bottom-0"};